<button
  mat-mini-fab
  color="primary"
  (click)="onScrollToTop()">
  <mat-icon>arrow_upward</mat-icon>
</button>
